import Vue from 'vue';

import template from './filters.html';
import colors from '../../helpers/colors';

Vue.component('filters', {
  template,
  props: [
    'activeFilters',
    'animating',
    'slideIndex',
  ],
  data: function () {
    // let statuses = [
    //   { display: 'Online', value: 'online' },
    //   { display: 'New', value: 'new' },
    // ];

    let domains = [
      { display: 'Tor', value: 'tor' },
      { display: 'ZeroNet', value: 'zeronet' },
      { display: 'I2P', value: 'i2p' },
    ];

    let languages = [
      { display: 'English', value: 'english' },
      { display: 'Russian', value: 'russian' },
      { display: 'French', value: 'french' },
      { display: 'German', value: 'german' },
    ];

    let topics = [
      { display: 'Counterfeiting', value: 'counterfeit' },
      { display: 'Cryptocurrency', value: 'cryptocurrency' },
      { display: 'Wikis', value: 'wiki' },
      { display: 'Markets', value: 'markets' },
      { display: 'Carding', value: 'carding' },
      { display: 'Hacking', value: 'black-hack' },
      { display: 'IT and Computing', value: 'computer' },
      { display: 'Drugs', value: 'drugs' },
    ];

    return {
      domains,
      languages,
      topics };
  },
  methods: {
    changeFilter: function (filter) {
      this.$emit('filter', filter);
    },

    determineClass: function (value) {
      let filters = this.activeFilters;
      let idx = this.slideIndex;

      if (idx === 3) {
        if (filters[0] === value) {
          return 'active';
        }
      } else if (idx === 4) {
        if (filters[0] === value) {
          return 'primary';
        } else if (filters[1] === value) {
          return 'secondary';
        }
      }

      return '';
    }
  },
});



// WEBPACK FOOTER //
// ./src/components/filters/filters.js